import React from 'react'
import { Thor } from 'component-library/compositions/Thor/Thor'
import { ContentWrapper } from '../ContentWrapper/ContentWrapper'
import { BaseCompositionProps } from '../types'
import { createRegisterableComposition } from 'common/routing/page-definition'
import { ThemeMargins, ContainerWidth } from 'component-library/__styling/settings/metrics'

export interface ThorRouteProps extends BaseCompositionProps {
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | keyof ThemeMargins
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | keyof ThemeMargins
    containerWidth?: ContainerWidth
    verticalSpacing?: keyof ThemeMargins
}

export const ThorRegistration = createRegisterableComposition<'main'>()(
    'thor',
    (contentAreas, props: ThorRouteProps) => (
        <ContentWrapper stretchColumns={props.stretchColumns} stretchSelf={props.stretchSelf}>
            <Thor {...props} mainContent={contentAreas.main} />
        </ContentWrapper>
    )
)
